

const { default: RHFAutocomplete } = require("../components/RHFAutocompleteSlab");
const { default: RHFDatePicker } = require("../components/RHFDatePicker");
const { default: RHFDropdown } = require("../components/RHFDropdownSlab");
const { default: RHFMultiselectDropdown } = require("../components/RHFMultiselectDropdownSlab");
const { default: RHFTextField } = require("../components/RHFTextField");
const { default: RHFFileUpload } = require("../components/RHFFileUpload");
const { default: RHFCheckbox } = require("../components/RHFCheckbox");
const { default: RHFRadioButton } = require("../components/RHFRadioGroup");


export const renderControls2 = (field, index, control, getDataFunc, reset, values) => {

    switch (field.DataType) {
        case "Textbox":
            return <RHFTextField key={`${index}${reset}`} formData={field} control={control} values={values} />;
        case "MultiselectDropdown":
            return (
                <RHFMultiselectDropdown
                    key={`${index}${reset}`}
                    formData={field}
                    control={control}
                />
            );
        case "Dropdown":
            return <RHFDropdown key={`${index}${reset}`} formData={field} control={control} values={values} />;
        case "Autocomplete":
            return <RHFAutocomplete key={`${index}${reset}`} formData={field} control={control} getDataFunc={getDataFunc} values={values} />;
        case "Date":
            return <RHFDatePicker key={`${index}${reset}`} formData={field} control={control} values={values} />;
        case "UploadFile":
        case "File":
            return <RHFFileUpload key={`${index}${reset}`} formData={field} control={control} values={values} />;
        case 'CheckBox':
            return <RHFCheckbox key={`${index}${reset}`} formData={field} control={control} values={values} />;
        case 'RadioButton':
            return <RHFRadioButton key={`${index}${reset}`} formData={field} control={control} values={values} />;
        default:
            return null;
    }
};